import { Permission } from '../../access-control/permissions'
import { type DomainAccessControlConfig } from '../../utils/domain/accessControl'

export const InstacartManagedReportsListPageAccessControl: DomainAccessControlConfig = {
  permissions: Permission.ReportsReports,
  restrictedBannersAllowed: true,
}
